import axios from 'axios';
import { contractorAuth } from './contractorAuth';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * The Links page's extras (routes/links-extras.js, migration 076): my
 * favourites, the firm's most used, today's ECB rates and my currencies.
 *
 * Everybody signed in has their own - a contractor too, on their portal
 * token. Before 076 every call is a 503 and the page simply goes without.
 */

const cfg = (extra = {}) => ({ ...(contractorAuth() || {}), ...extra });

export const loadExtras = () => axios.get(`${API_BASE}/links/extras`, cfg()).then((r) => r.data);
export const loadRates = () => axios.get(`${API_BASE}/links/rates`, cfg()).then((r) => r.data);
export const saveCurrencies = (currencies) => axios.put(`${API_BASE}/links/rates/currencies`, { currencies }, cfg()).then((r) => r.data);

export const star = (id, position) => axios.put(`${API_BASE}/links/favourites/${id}`,
  position === undefined ? {} : { position }, cfg()).then((r) => r.data.favourites);
export const unstar = (id) => axios.delete(`${API_BASE}/links/favourites/${id}`, cfg()).then((r) => r.data.favourites);
export const moveFavourite = (id, position) => axios.patch(`${API_BASE}/links/favourites/${id}`, { position }, cfg()).then((r) => r.data.favourites);

/**
 * One open, counted by the server (once per person per link per ten
 * minutes). Fire and forget, and it must survive the click that caused it:
 * `keepalive` lets it finish if the page goes away. Not navigator.sendBeacon -
 * a beacon cannot carry the Authorization header every caller here signs in
 * with, so it would arrive as nobody. lib/apiClient.js adds the staff token
 * to fetch; a contractor's comes from contractorAuth.
 */
export function recordOpen(id) {
  try {
    const headers = contractorAuth()?.headers || {};
    window.fetch(`${API_BASE}/links/items/${encodeURIComponent(id)}/open`, { method: 'POST', keepalive: true, headers })
      .catch(() => { /* a count is never worth an error */ });
  } catch { /* nor is a browser without fetch */ }
}
